const initCollectionDescription = () => {
  const descriptionShortEl = document.querySelector('[data-collection-description-short]');
  const descriptionFullEl = document.querySelector('[data-collection-description-full]');
  if (!descriptionShortEl && !descriptionFullEl) return;
  const toggleEl = document.querySelector('[data-collection-description-toggle]');
  if (!toggleEl) return;
  const toggleShortTextEl = toggleEl.querySelector('[data-collection-description-toggle-short]');
  const toggleFullTextEl = toggleEl.querySelector('[data-collection-description-toggle-full]');

  const toggleChangeEls = [descriptionShortEl, descriptionFullEl, toggleShortTextEl, toggleFullTextEl];
  toggleEl.addEventListener('click', () => toggleChangeEls.forEach(element => element.classList.toggle('hidden')));
};

export default initCollectionDescription;
